import { AppState } from '../../..';
import { Dispatch, connect } from 'react-redux';
import {
  ServiceWorkOrderSearchComponentProperties,
  ServiceWorkOrderSearchComponent
} from './service-work-order-search.component';
import { searchServiceWorkOrder, resetSWOSearch } from '../../service-work-order.actions';

function mapStateToProps(
  state: AppState,
  ownProps: { contractId?: number; showContractSearch?: boolean }
): Partial<ServiceWorkOrderSearchComponentProperties> {
  return {
    contractId: ownProps.contractId,
    message: state.serviceWorkOrder.message,
    query: state.serviceWorkOrder.query,
    loading: state.serviceWorkOrder.loading,
    pageCount: state.serviceWorkOrder.pageCount,
    pageNumber: state.serviceWorkOrder.pageNumber,
    pageSize: state.serviceWorkOrder.pageSize,
    showInactive: ownProps.contractId ? true : state.serviceWorkOrder.showInactive,
    SWOList: state.serviceWorkOrder.SWOList,
    showContractSearch: ownProps.showContractSearch === undefined ? true : ownProps.showContractSearch.valueOf()
  };
}

function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<ServiceWorkOrderSearchComponentProperties> {
  return {
    resetSWOSearch: () => {
      dispatch(resetSWOSearch());
    },
    getSWOList: (query, pageSize, pageNumber, orderBy, orderDirection, showInactive, contractId) =>
      dispatch(searchServiceWorkOrder(query, pageSize, pageNumber, orderBy, orderDirection, showInactive, contractId))
  };
}

export const ServiceWorkOrderSearch = connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceWorkOrderSearchComponent);



// WEBPACK FOOTER //
// ./src/service-work-order/_components/service-work-order-search/service-work-order-search.container.ts